import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';

const Button = ({
  onClick, children, variant = 'primary', disabled, className
}) => {
  const buttonStyle = styles[variant];

  return (
    <button type="button" disabled={disabled} className={`${styles.button} ${buttonStyle} ${className}`} onClick={onClick}>
      {children}
    </button>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'dark', 'secondary', 'blue'])
};

export default Button;
